<!-- start banner Area -->
<section class="top-banner">
  <div class="top-banner-img" style="">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 style="padding: 30px 0px 0px 0px !important;"> CV thèque (Tous les candidats)</h1>
          <div class="container">
            <div class="row  justify-content-center">
              <div class="col-lg-9">
                <div id="searchOtherBlock" style="display: " class="row justify-content-center mb-1 p-2">
                  <div class="mb-3 col-md-4 col-lg-4 form-cols" id="default-selects2">
                    <select class="form-control form-select form-select-sm" [(ngModel)]="profession"
                      style="height: 50px !important;">
                      <option value="">METIERS/PROFESSIONS...</option>
                      <option value="{{ profession.getId() }}" *ngFor="let profession of professionList">{{
                        profession.getLibelle()
                        }}</option>
                    </select>
                  </div>
                  <div class="mb-3 col-md-4 col-lg-4 form-cols" id="">
                    <div class="default-select" id="default-selects2">
                      <select class="form-control form-select form-select-sm" [(ngModel)]="level_of_study"
                        style="height: 50px !important;">
                        <option value="">NIVEAU D'ETUDE...</option>
                        <option value="Secondaire">Secondaire</option>
                        <option value="Terminal">Terminal</option>
                        <option value="Formation professionnelle">Formation professionnelle</option>
                        <option value="Baccalauréat">Baccalauréat</option>
                        <option value="Universitaire sans diplôme">Universitaire sans diplôme</option>
                        <option value="BAC + 2">BAC + 2</option>
                        <option value="Licence(BAC + 3)">Licence(BAC + 3)</option>
                        <option value="Master 1(BAC + 4)">Master 1(BAC + 4)</option>
                        <option value="Master 2(BAC + 5)">Master 2(BAC + 5)</option>
                        <option value="Doctorat(BAC + 7)">Doctorat(BAC + 7)</option>
                      </select>
                    </div>
                  </div>
                  <div class="mb-3 col-md-4 col-lg-4 form-cols">
                    <div class="default-select" id="default-selects2" style="height: 50px !important;">
                      <select class="form-control form-select form-select-sm" [(ngModel)]="years_of_experience"
                        style="height: 50px !important;">
                        <option value="">ANNEES D'EXPERIENCES...</option>
                        <option value="Sans experience">Sans experience</option>
                        <option value="Moins d'un an">Moins d'un an</option>
                        <option value="1 à 2ans">1 à 2ans</option>
                        <option value="3 à 5ans">3 à 5ans</option>
                        <option value="6 à 10ans">6 à 10ans</option>
                        <option value="Plus de 10ans">Plus de 10ans</option>
                      </select>
                    </div>
                  </div>
                  <!-- Second search row -->

                  <div class="col-lg-4 form-cols">
                    <div class="default-select" id="default-selects2">
                      <select class="form-control" id="position_level" [(ngModel)]="position_level"
                        style="height: 50px !important;">
                        <option value="">NIVEAU DE POSTE...</option>
                        <option value="Stagiaire/Etudiant">Stagiaire/Etudiant</option>
                        <option value="Jeune diplomé">Jeune diplomé</option>
                        <option value="Débutant/Junior">Débutant/Junior</option>
                        <option value="Confirmé/Experimenté">Confirmé/Experimenté</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4 form-cols">
                    <div class="default-select" id="default-selects">
                      <select class="form-control" [(ngModel)]="training" style="height: 50px !important;">
                        <option value="">FORMATION...</option>
                        <option value="{{ training.getId() }}" *ngFor="let training of trainingList">{{
                          training.getLibelle() }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-lg-4 form-cols">
                    <div class="default-select" id="default-selects2">
                      <select class="form-control" [(ngModel)]="language_level" style="height: 50px !important;">
                        <option value="">NIVEAU DE LANGUE...</option>
                        <option value="{{ language['id'] }}" *ngFor="let language of languageList">{{
                          language['libelle'] }}
                        </option>
                      </select>
                    </div>
                  </div>

                </div>
                <!-- Text show more -->
                <!-- <div class="col-lg-12 justify-content-center ">
                <div class="col-lg-2 form-cols " style="margin-top: -15px; ">
                  <div id="showMoreLabel" class="labelBlock" style="color: #00027D !important; "
                    (click)="functionsService.showOrHideSearchBlockField('searchOtherBlock', 'showMoreLabel')">
                    <span>Afficher plus</span>
                  </div>
                </div>
              </div> -->
                <!-- Button search -->
                <div class="row justify-content-center">
                  <div class="col-md-4" style="">
                    <button type="button" class="btn btn-submit" (click)="searchCandidates()">Rechercher</button>
                  </div>
                </div>


              </div>
            </div>
          </div>
          <p class="text-white link-nav"><a *ngIf="userType == 'entreprise'" [routerLink]="['/accueil', 'entreprise']"
              style="color: #ff5a00 !important">Accueil</a> <a *ngIf="userType == 'admin'" [routerLink]="['/admin']"
              style="color: #ff5a00 !important">Accueil</a> <span class="lnr lnr-arrow-right"></span> <a
              routerLink="/tous-les-candidats" style="color: white;"> CV thèque (Tous les candidats)</a></p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->


<section class="post-area section-gap">
  <div class="container">

    <!-- Loading -->
    <div class="row d-flex justify-content-center mt-5 mb-2" *ngIf="isLoading">
      <span style="color: red;text-align: center;">Chargement...</span>
    </div>
    <br><br>
    <!-- Button to export data -->
    <div class="row  mb-2">
      <span style="color: green">{{ candidatesList.length }} enregistrement (s) trouvé(s)</span>
    </div>
    <div class="container">
      <button class="btn btn-danger  mb-2" style="float: right;" (click)="exportToExcel()">Exporter Excel</button>
    </div>



    <!-- Nb record selected -->
    <div class="row d-flex justify-content-center mb-4" *ngIf="candidateSelected.length > 0">
      <span style="color: red;">{{ candidateSelected.length }} enregistrement (s) selectionné(s)</span>
    </div>

    <!-- Datatable -->
    <div class="row justify-content-center d-flex mb-5" style="width: 100%; overflow: auto; max-height: 655px;">
      <div class="col-lg-12 post-list">
        <table id="example" class="table table-striped table-bordered nowrap" style="width:100%">
          <thead>
            <tr>
              <th><input id="checkbox_all" type="checkbox" (click)="selectedRow('all', 'checkbox')"></th>
              <th>Nom & prénom</th>
              <th>Sexe</th>
              <th>Age</th>
              <th>Email</th>
              <th>Téléphone</th>
              <th>Diplômes</th>
              <th>Profession</th>

              <!-- <th>Niveau de poste</th> -->
              <th>Dossier</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let candidates of candidatesList" (click)="selectedRow(candidates.getId(), 'row')">
              <td><input id="checkbox_{{ candidates.getId() }}" type="checkbox" disabled></td>
              <td>{{ candidates.getFirstName() }} {{ candidates.getLastName() }}</td>
              <td>{{ candidates.getGender() }}</td>
              <td>{{ calculateAge(candidates.getDateBirth()) }} ans</td>
              <td>{{ candidates.getEmail() }}</td>
              <td>{{ candidates.getPhone1() }} / {{ candidates.getPhone2() }}</td>
              <td>
                <p *ngFor="let trainings of candidates.getCandidatesTrainings()">
                  {{ trainings['level_of_study']}} en {{
                  trainings['trainings']['libelle'] }}
                </p>
                <!-- {{ candidates.getCandidatesProfiles().getProfessions().getLibelle() }} -->
              </td>
              <td>-</td>
              <!-- <td>{{ candidates.getCandidatesProfiles().getPositionLevel() }}</td> -->
              <td>
                <span (click)="getCandidateProfile(candidates.getId())"
                  class="btn btn-primary a-btn-slide-text mr-1"><svg xmlns="http://www.w3.org/2000/svg" width="16"
                    height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
                    <path
                      d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                  </svg>
                </span>

              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>
<!-- End post Area -->